<template>
  <div id="box">
    <HeaderView></HeaderView>
    <!-- <img
      src="/img/product/images/banner.jpg"
      alt=""
      class="responsive-img"
    /> -->
    <img
      src="/img/product/images/1017_02.jpg"
      alt=""
      class="responsive-img"
    />
    <!-- <video preload="auto" src="/video/canpin-cc.mp4" autoplay loop muted style="display:block;width:100%;height:670px;margin:0 auto"></video> -->

    <section class="section1">
      <div class="section-content1">
        <h1 class="section-title">匠心产品</h1>
        <div class="product-list">
          <div
            v-for="(item, idx) in productFoods"
            :key="item.id"
            class="product-img"
            :class="{ active: activeProduct === idx }"
            @click="selectProduct(idx)"
          >
            <img :src="item.image" alt="" />
            <p :style="{ marginTop: idx === 0 ? '0.8rem' : idx === 1 ? '0.3rem' : '-3rem', }">{{ item.title }}</p>
          </div>
        </div>
        <div class="product-tabs">
          <div
            class="tab-list"
            v-if="
              productTabs[activeProduct] && productTabs[activeProduct].length
            "
          >
            <div
              v-for="(tab, idx) in productTabs[activeProduct]"
              :key="productFoods[activeProduct].list[idx].id"
              class="tab-item"
              :class="{ active: activeTab[activeProduct] === idx }"
              @click="selectTab(productFoods[activeProduct].list[idx].id)"
            >
              {{ tab }}
            </div>
          </div>
          <div
            class="tab-line"
            v-if="productTabs[activeProduct] && productTabs[activeProduct].length"
            :style="{
              left:
                (activeTab[activeProduct] + 0.5) *
                  (100 / productTabs[activeProduct].length) -
                2 +
                '%',
            }"
          ></div>
          <div
            class="tab-line2"
            v-if="productTabs[activeProduct] && productTabs[activeProduct].length"
            :style="{
              left:
                activeTab[activeProduct] *
                  (100 / productTabs[activeProduct].length) +
                '%',
                width: 100 / productTabs[activeProduct].length + '%',

            }"
          ></div>
        </div>
        <div class="tab-content" id="product-detail">
          <div class="content-panel">
            <!-- {{ productContents[activeProduct][activeTab[activeProduct]] }} -->
            <!-- <div class="product-content-top" v-if="productone && productone.length !== 0">
              <img :src="productone.image" alt="" style="width:650px; height:365px;border-radius:15px" />
              <div class="product-content-top-text">
                <h2>{{ productone.titile }}</h2>
                <p>[产品名称]{{ productone.title }}</p>
                <p>[包装规格]{{ productone.brief }}</p>
              </div>
            </div> -->
            <div class="product-content-bottom">
              <div v-if="!isDataReady" class="swiper-loading">
                <div class="loading-spinner"></div>
                <p>正在加载产品数据...</p>
              </div>
              <!-- :autoplay="{ delay: 6000, disableOnInteraction: false }" -->
              <Swiper
                v-else-if="currentProducts.length > 0"
                :key="`swiper-${activeProduct}-${activeTab[activeProduct]}`"
                :modules="modules"
                :slides-per-view="1"
                :space-between="0"
                :loop="false"
                :watch-overflow="true"
                :autoplay="false"
                :navigation="{
                  prevEl: '.swiper-button-prev',
                  nextEl: '.swiper-button-next',
                }"
                class="honor-swiper"
                ref="productSwiper"
                @swiper="onSwiper"
              >
                <SwiperSlide
                  v-for="(group, gIdx) in honorGroups"
                  :key="gIdx"
                  class="product-slide"
                >
                  <div v-for="item in group" :key="item.id" style="width:30%;">
                    <div class="product-box" @click="openModal(item)">
                      <img :src="item.image" alt="" />
                      <div class="product-desc">

                        <h3>{{ item.title }}</h3>
                        <!-- <hr />
                        <p>[包装规格]{{ item.brief }}</p> -->
                        <!-- <p>【单价(元/kg)】{{ item.price }}</p> -->
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div v-else class="swiper-empty">
                <p>暂无产品数据</p>
              </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div
              class="swiper-button-next"
              style="background: rgb(230, 0, 19)"
            ></div>
          </div>
        </div>
      </div>
    </section>
    <!-- 产品详情模态框 -->
    <teleport to="body">
      <div v-if="modalVisible" class="modal-mask" @click.self="closeModal">
        <div class="modal-container">
          <div class="modal-content">
            <button class="modal-close" @click="closeModal">×</button>
            <div class="modal-body">
              <div class="modal-left">
                <!-- ----------- -->
                <Swiper
                  :modules="modules"
                  :slides-per-view="1"
                  :space-between="0"
                  :loop="true"
                  :autoplay="{ delay: 3000, disableOnInteraction: false }"
                  :pagination="{ clickable: true }"
                  class="modal-swiper"
                >
                  <SwiperSlide
                    v-for="(img, idx) in selectedProduct.b_image_arr"
                    :key="idx"
                  >
                    <img :src="img" alt="" />
                  </SwiperSlide>
                </Swiper>
                <!-- ---------- -->
              </div>
              <div class="modal-right">
                <h3><span v-html="selectedProduct.title"></span></h3>
                <hr />
                <p>产品名称：<span v-html="selectedProduct.title"></span></p>
                <p>产品规格：<span v-html="selectedProduct.brief"></span></p>
                <p>产品风味: <span v-html="selectedProduct.fengwei"></span></p>
                <!-- <p>产品原料: {{ selectedProduct.yuanliao }}</p> -->
                <p>产品类别: <span v-html="selectedProduct.leixing"></span></p>
                <p>贮存条件:<span v-html="selectedProduct.zhucun"></span></p>
                <p>保质期: <span v-html="selectedProduct.baozhi"></span></p>
                <p>食用方法：<span v-html="selectedProduct.caozuo"></span></p>
                <!-- <p>加工方式：{{ selectedProduct.jiagong }}</p> -->
                <!-- <p>{{ selectedProduct.price }}</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </teleport>

    <FooterView></FooterView>
  </div>
</template>

<script>
import apiServe from "../services/index.js";
import HeaderView from "../components/HeaderView2.vue";
import FooterView from "../components/FooterView.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
export default {
  components: {
    HeaderView,
    Swiper,
    SwiperSlide,
    FooterView,
  },
  data() {
    return {
      activeProduct: 0,
      activeTab: [0, 0, 0],
      productTabs: [[], [], []],
      productFoods: [{ list: [] }, { list: [] }, { list: [] }],
      currentProducts: [],
      productone: null,
      modalVisible: false,
      selectedProduct: null,
      honorImages: [],
      isDataReady: false,
      copywriting: {},
      swiperInstance: null,
    };
  },
  computed: {
    modules() {
      return [Pagination, Autoplay, Navigation];
    },
    honorGroups() {
      const groups = [];
      const isMobile = window.innerWidth <= 767;
      const groupSize = isMobile ? 1 : 6;
      for (let i = 0; i < this.currentProducts.length; i += groupSize) {
        groups.push(this.currentProducts.slice(i, i + groupSize));
      }
      return groups;
    },
  },
  async mounted() {
    await this.fetchProductData();
    apiServe.getCopyWriting({}, "get").then((res) => {
        this.copywriting = res.data;
      })
    this.handleHashChange();
  },
  watch: {
    '$route.query.brand'() {
      this.handleHashChange();
    }
  },
  methods: {
    handleHashChange() {
      const brand = this.$route?.query?.brand;
      const brandIndexMap = {
        'taigang': 0,
        'daxijia': 1,
        'baixiaole': 2
      };
      
      if (brand && brandIndexMap[brand] !== undefined) {
        const targetIdx = brandIndexMap[brand];
        if (targetIdx !== this.activeProduct) {
          this.selectProduct(targetIdx);
          this.$nextTick(() => {
            this.scrollToProductDetail();
          });
        }
      }
    },
    onSwiper(swiper) {
      this.swiperInstance = swiper;
    },
    openModal(item) {
      // --------
      let bImageArr = [];
      if (item.b_image) {
        if (Array.isArray(item.b_image)) {
          bImageArr = item.b_image;
        } else if (typeof item.b_image === 'string') {
          bImageArr = item.b_image.split(',').map(url => url.trim());
        }
      }
      // -------
      // this.selectedProduct = item;
      this.selectedProduct = { ...item, b_image_arr: bImageArr };
      this.$nextTick(() => {
        this.modalVisible = true;
      });
    },
    closeModal() {
      this.modalVisible = false;
      this.selectedProduct = null;
    },
    selectProduct(idx) {
      if (idx === this.activeProduct) return;
      this.activeProduct = idx;
      const list = this.productFoods[idx]?.list || [];
      this.$set(this.productTabs, idx, list.map((item) => item.name));
      this.$set(this.activeTab, idx, 0);
      if (list.length) {
        this.fetchProductList(list[0].id);
      } else {
        this.currentProducts = [];
        this.productone = null;
      }
    },
    async selectTab(id) {
      const tabIndex = this.productFoods[this.activeProduct].list.findIndex(item => item.id === id);
      if (tabIndex === -1) return;
      this.$set(this.activeTab, this.activeProduct, tabIndex);
      await this.fetchProductList(id);
    },
    async fetchProductData() {
      try {
        const res = await apiServe.getIndexData({}, "get");
        this.productFoods = res.data.product || [];

        const categoryId = this.$route?.query.categoryId;
        const productId = Number(this.$route?.query.productId);

        let targetProductIdx = 0;

        if (categoryId) {
          const idx = this.productFoods.findIndex(item => String(item.id) === String(categoryId));
          if (idx !== -1) {
            targetProductIdx = idx;
          }
        }

        this.activeProduct = targetProductIdx;
        const list = this.productFoods[targetProductIdx]?.list || [];
        this.$set(this.productTabs, targetProductIdx, list.map(item => item.name));
        this.$set(this.activeTab, targetProductIdx, 0);

        // 如果 URL 带了 productId，则找到它在当前一级分类 list 中的索引
        if (productId) {
          const tabIndex = list.findIndex(item => item.id === productId);
          if (tabIndex !== -1) {
            this.$set(this.activeTab, targetProductIdx, tabIndex);
            await this.fetchProductList(productId);
          } else {
            // 找不到对应 productId 则退回到第一个 tab
            await this.fetchProductList(list[0]?.id ?? 21);
          }
        } else {
          // 没有 productId 就默认第一个 tab
          const fetchId = list[0]?.id ?? 21;
          await this.fetchProductList(fetchId);
        }

        if (productId) {
          await this.$nextTick();
          this.scrollToProductDetail();
        }
        this.isDataReady = true;
      } catch (e) {
        console.error("fetchProductData error:", e);
      }
    },

    async fetchProductList(categoryId) {
      try {
        const res = await apiServe.getProductData({ category_id: categoryId, limit: 12, page: 1 });
        this.currentProducts = res.data.product || [];
        this.productone = res.data.productone || null;
        this.honorImages = this.currentProducts.map(item => item.image);
        this.$nextTick(() => {
          if (this.swiperInstance) {
            this.swiperInstance.update();
            this.swiperInstance.updateSize();
            this.swiperInstance.updateSlides();
            this.swiperInstance.updateProgress();
            this.swiperInstance.updateSlidesClasses();
            if (this.swiperInstance.navigation && this.swiperInstance.navigation.update) {
              this.swiperInstance.navigation.update();
            }
          }
        });
      } catch (e) {
        console.error("fetchProductList error:", e);
      }
    },
    scrollToProductDetail() {
      const el = document.getElementById("product-detail");
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - 350;
      window.scrollTo({ top, behavior: "smooth" });
    },
  },
  metaInfo() {
    return {
      title: this.copywriting?.title,
      meta: [
        { name: 'keywords', content: this.copywriting?.keywords },
        { name: 'description', content: this.copywriting?.description}
      ]
    };
  }
};
</script>

<style scoped>
/* 加载状态和空数据状态样式 */
.swiper-loading, .swiper-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  text-align: center;
  color: #666;
  font-size: 1.2rem;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #14419e;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.swiper {
  width: 100%;
  max-width: 1370px;
  margin: 0 auto;

}
.product-content-bottom {
  margin-top: 3rem;
  position: relative;
}
.product-slide {
  /* width: 90% !important; */


  margin: 0 auto !important;
  /* padding: 0 0 0 4.5rem; */
  display: flex;
  flex-wrap: wrap;
  gap:3.5vw;
  justify-content: flex-start;
}
.product-box {
  /* width: 420px; */
  /* width: clamp(21vw,420px,420px); */
  /* height: 27rem; */
  flex: 0 0 100%;
  display: flex;
  flex-direction: column;
  /* gap: 1.5rem; */
  background-color: #f8f8f8;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.3s, border-bottom 0.3s;
  border-bottom: 3px solid transparent;
  margin-bottom: 1.5rem;
}

/* 模态框样式 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 99.2vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-container {
  background: #fff;
  border-radius: 12px;
  width: 90vw;
  max-width: 1200px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.modal-content {
  position: relative;
  padding: 2rem;
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  font-size: 2rem;
  color: #666;
  cursor: pointer;
  z-index: 10;
}

.modal-body {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  align-items: center;
}

.modal-left {
  flex: 0 0 70%;
}

.modal-left img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

.modal-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.modal-right h3 {
  font-size: 1.8rem;
  color: #14419e;
  margin: 0;
}

.modal-right hr {
  border: none;
  border-top: 1px solid #ddd;
  margin: 0.5rem 0;
}

.modal-right p {
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 767px) {
  .modal-body {
    flex-direction: column;
  }
  .modal-left {
    flex: 1;
  }
}

.product-box::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 45%;
  /* background: linear-gradient(to bottom, #14419e, rgba(24, 144, 255, 0)); */
  background: linear-gradient(to bottom, rgb(243 197 170), rgba(24, 144, 255, 0));
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 2;
  pointer-events: none;
}
.product-box:hover::before {
  opacity: 1;
}
.product-box:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  /* border-bottom: 3px solid #14419e; */
}
.product-box:hover .product-desc * {
  /* color: #14419e; */
  color: #FA5151;
}
.product-box:hover hr {
  border-color: #14419e;
}
.product-box img {
  width: 100%;
  aspect-ratio: 410 / 320;
  position: relative;
  z-index: 1;
}

.swiper-wrapper {
  margin: 0 auto;

  width: 90%;
}

.product-list {
  width: 100%;
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  overflow-x: auto;
  padding: 1rem 0;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.product-list::-webkit-scrollbar {
  display: none;
}
.product-img {
  width: 13rem;
  height: 15rem;
  border-radius: 5%;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.3s;
  flex-shrink: 0;
}
.product-img img {
  transition: transform 0.4s ease;
   width: 130%;
}
.product-img:last-child img{
  width: 165%;
}
.product-img.active p {
  /* border-color: #e60012; */
  font-weight: 600;
  color: #e60013;
}
.product-img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.product-img p {
  font-size: 1.1rem;
  font-weight: 400;
  color: #000;
  margin-top: 0.5rem;
  text-align: center;
}
@media (max-width: 767px) {
  .product-img p {
    font-size: 0.9rem;
  }
}
.responsive-img {
  width: 100%;
  height: auto;
  display: block;
}

.section1 {
  padding: 3rem 2rem;
  /* background-color: #f7f7f7; */
}

@media (min-width: 768px) {
  .section1 {
    padding: 4rem 5rem;
  }
}

@media (min-width: 1024px) {
  .section1 {
    padding: 5rem 10rem;
  }
}
.section-title {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 500;
}

@media (min-width: 768px) {
  .section-title {
    font-size: 3rem;
    margin-bottom: 5rem;
  }
}

.product-tabs {
  position: relative;
  margin: 2rem auto 0;
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
}

.product-tabs::-webkit-scrollbar {
  display: none;
}
.tab-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  border-bottom: 2px solid #ccc;
  min-width: 600px;
}
.tab-item {
  flex: 1;
  text-align: center;
  padding: 1rem 0;
  cursor: pointer;
  font-size: 1.2rem;
  color: #333;
  transition: color 0.3s;
}
.tab-item.active {
  color: #e60013;
  font-weight: 600;
}
.tab-line {
  position: absolute;
  bottom: -1px;
  left: 5.5rem;
  height: 2.5px;
  width: 4rem;
  background: #e60013;
  transition: left 0.3s ease;
  z-index: 2;
}
.tab-line2 {
  display:none;
  position: absolute;
  bottom: -1px;
  left: 5.5rem;
  height: 2.5px;
  width: 4rem;
  background: #e60013;
  transition: left 0.3s ease;
  z-index: 2;
}
.tab-content {
  margin-top: 2rem;
 

}
.content-panel {
  max-width: 100%;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  font-size: 1.5rem;
  color: #555;
  position: relative;
}
.product-content-top {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
  border-radius: 8px;
  text-align: center;
  padding: 2rem;
}

@media (min-width: 768px) {
  .product-content-top {
    width: 90%;
    min-width: 900px;
    flex-direction: row;
    text-align: left;
    padding: 0;
  }
}
.product-content-top-text {
  margin: 2rem auto 0;
  padding: 0 1rem;
}

@media (min-width: 768px) {
  .product-content-top-text {
    margin: 4rem auto;
    padding: 0;
  }
}
.product-content-top-text h2 {
  margin-bottom: 2.2rem;
  font-weight: 500;
}
.product-content-top-text p {
  margin: 3.6rem 0;
}
.product-desc {
  text-align: left;
  padding: 1rem 1.8rem;
  font-size: clamp(0.9rem, 2.2vw, 1.2rem);
}
.product-desc h3 {
  /* margin-bottom: 1rem; */
  text-align: center;
}
.product-desc p {
  line-height: 1.6;
  margin: 0.5rem 0;
}
.product-desc hr {
  width: 100%;
  margin: 1rem auto;
}

.swiper-button-next,
.swiper-button-prev {
  color: #fff;
  position: absolute;
  top: 50%;
  margin-top: 20px;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  background: #14419e;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 10px;
  /* transition: background 0.3s; */
}
/* 缩小箭头图标 */
::v-deep(.swiper-button-prev svg),
::v-deep(.swiper-button-next svg) {
  width: 25%;
}
.swiper-button-next:active,
.swiper-button-prev:active {
  background: #e60013;
}
.swiper-button-next {
  right: 0%;
}
.swiper-button-prev {
  left: 0%;
}

@media (max-width: 767px) {
  .tab-line{
    display:none;
  }
  .tab-line2 {
    display: block;
  }

  .section1 {
    padding: 3rem 0rem;
  }
  .product-list{
    gap: 0;
  }
  .product-img {
    width: 30vw;
    height: auto;
    max-width: 13rem;
  }
  .product-img img {
    width: 100%;
    height: auto;
  }
  .tab-item{
    font-size: 0.8rem;
  }

  video {
    height: auto !important;
  }

  .product-list {
    width: 100%;
    max-width: 100%;
  }
  .tab-list {
    width: 100%;
    min-width: unset;
  }
  .product-content-top {
    padding: 1rem;
    width: auto;
  }
  .product-content-top > img {
    width: 100% !important;
    height: auto !important;
  }
  .product-content-top-text{
    margin: 0;
}

  .product-box {
    width: 250px;
    /* flex: 0 0 90%; */
    /* height: auto;
    width: 90%; */
    /* height: 20rem; */
  /* flex: 0 0 90%; */
    margin: 20px auto;
  }
  .product-box img {
    width: 100%;
    height: 50%;
    /* max-height: clamp(8rem, 25vw, 12rem);
    object-fit: contain; */
  }
  .product-desc {
    padding: 15px 0.5rem;
    font-size: clamp(0.8rem, 2.2vw, 0.9rem);
  }
  .product-slide {
    gap: 0;
    justify-content: center;
  }
  .product-slide > div {
    width: 90% !important;
    margin: 0 auto;
  }
  .swiper-wrapper {
    width: 95%;
  }
  .swiper-button-next,
  .swiper-button-prev {
    bottom: 0;
    /* top: auto; */
    width: 32px;
    height: 32px;
  }
  .swiper-button-next {
    right: 5%;
  }
  .swiper-button-prev {
    left: 5%;
  }
}
</style>